module.exports = __webpack_public_path__ + "static/media/breakfast4.e24018ae.png";